import { serviceModel } from "../../models";
export function createLocalActionContext(_ref) {
  let {
    localService,
    now,
    relationshipState,
    effectiveDate,
    isApprovedRelationship,
    updateLocalService,
    featureFlags,
    logBI
  } = _ref;
  return {
    serviceId: localService.id,
    service: localService,
    now,
    relationshipState,
    relationshipEffectiveDate: effectiveDate,
    isApprovedRelationship,
    isAmendedService: serviceModel.isFromAmendment(localService),
    onPausedChange: (_, paused) => updateLocalService(s => serviceModel.setPaused(s, paused)),
    onBillOnAcceptanceChange: (_, billOnAcceptance) => updateLocalService(s => serviceModel.setSkipBillingOnAcceptance(s, !billOnAcceptance, featureFlags)),
    onProratedChange: (_, prorated) => updateLocalService(s => serviceModel.setProrated(s, prorated)),
    onOptionalChange: (_, optional, includedByDefault) => updateLocalService(s => serviceModel.setParticipation(s, optional, includedByDefault)),
    onLimitBillingTimesChange: (_, enabled, limit) => updateLocalService(s => enabled ? serviceModel.setMaxCharges(s, enabled, limit) : serviceModel.deleteMaxCharges(s)),
    onAutoPriceIncreaseChange: (_, priceIncrease) => updateLocalService(s => serviceModel.isAwaitingApproval(s.status) ? serviceModel.setPriceIncrease(s, priceIncrease) : serviceModel.setPriceIncreaseChanges(s, priceIncrease)),
    onQboClassChange: (_, integratedClass) => updateLocalService(s => serviceModel.setIntegratedClass(s, integratedClass)),
    onKarbonChange: (_, karbon, options) => updateLocalService(s => serviceModel.setKarbonIntegration(s, karbon, options)),
    onFinancialCentsChange: (_, financialCents, options) => updateLocalService(s => serviceModel.setFinancialCentsIntegration(s, financialCents, options)),
    onLimitedTimeDiscountOfferChange: (_, limitedTimeDiscountOffer) => updateLocalService(s => serviceModel.setLimitedTimeDiscountOffer(s, limitedTimeDiscountOffer)),
    onDiscountPeriodExpirationChange: (_, discountPeriodExpiration) => updateLocalService(s => serviceModel.setDiscountPeriodExpiration(s, discountPeriodExpiration)),
    onPreapprovedAmountChange: (_, amount, controlledByAdvancedSettings) => updateLocalService(s => serviceModel.isAwaitingApproval(s.status) ? serviceModel.setPreapprovedAmount(s, amount, controlledByAdvancedSettings) : serviceModel.setPreapprovedAmountChanges(s, amount, controlledByAdvancedSettings)),
    onStartBillingAtChange: (_, startBillingAt) => updateLocalService(s => serviceModel.setStartBillingAt(s, startBillingAt)),
    logBI
  };
}